import { Fill, Icon, Stroke, Style } from "ol/style";
import pinPng from "../../img/pin.png";

export const trackStyle = new Style({
    image: new Icon({
        src: pinPng,
        scale: 0.25,
        anchorOrigin: "bottom-left",
        anchor: [0.5, 0],
        offsetOrigin: "bottom-left",
        offset: [0, 4]
    }),
    stroke: new Stroke({
        color: [0, 0, 255],
        width: 2
    })
});

export const selectedTrackStyle = new Style({
    stroke: new Stroke({
        color: [255, 0, 0],
        width: 2
    })
});

export const profileStyle = new Style({
    fill: new Fill({ color: "#ccc" })
});
